import Api from "../utils/api";

const PackageService = {
  admin: {
    get: async (params = {}) =>
      Api.createResponse("app/admin/packages/", params),
    create: async (params = {}) =>
      Api.createResponse("app/admin/packages/create", params),
    delete: async (params = {}) =>
      Api.createResponse("app/admin/packages/delete", params),
    update: async (params = {}) =>
      Api.createResponse("app/admin/packages/update", params),
    changeStatus: async (params = {}) =>
      Api.createResponse("app/admin/packages/change-status", params),
    uploadPhotos: async (params = {}) =>
      Api.createResponse("app/admin/packages/photos/upload", params),
    deletePhotos: async (params = {}) =>
      Api.createResponse("app/admin/packages/photos/remove", params),
    changePhotosStatus: async (params = {}) =>
      Api.createResponse("app/admin/packages/photos/status", params),
  },
};

export default PackageService;
